import { useEffect, useCallback } from 'react';

const useSaveChangesPrompt = (condition: boolean): void => {
  const triggerPrompt = useCallback(
    (e: BeforeUnloadEvent) => {
      // Modern browsers don't allow custom messages anymore, but you still need to set e.returnValue to a string to trigger
      if (condition) {
        e.preventDefault();
        e.returnValue = '';
        setTimeout(() => window.dispatchEvent(new CustomEvent('SAVE_CHANGES_PROMPT')), 500);
      }
    },
    [condition]
  );

  useEffect(() => {
    window.addEventListener('beforeunload', triggerPrompt);

    return () => {
      window.removeEventListener('beforeunload', triggerPrompt);
    };
  }, [condition, triggerPrompt]);
};

export default useSaveChangesPrompt;
